// Traveller reviews — EDIT THIS FILE to add, update or remove reviews.
// Photos are real traveller moments shared by our guests (served from /public/images).
export const REVIEWS = [
  {
    name: "Priya & Rohan",
    masked: "Mehta",
    suffix: "",
    trip: "Honeymoon",
    rating: 5,
    image: "/images/special-honeymoon.jpg",
    text: "From the houseboat night on Dal Lake to the snow in Gulmarg, every detail felt planned just for us. Our trip expert stayed in touch throughout — it never felt like dealing with an agency.",
  },
  {
    name: "The",
    masked: "Sharma",
    suffix: "Family",
    trip: "Kashmir Family Holiday · 6 Nights",
    rating: 5,
    image: "/images/family-travellers.jpg",
    text: "Travelling with parents and two kids, we worried about the pace. The team adjusted days around us, the driver was wonderful with the children, and having someone local to call anytime made all the difference.",
  },
  {
    name: "Ananya,",
    masked: "Kunal",
    suffix: "& Friends",
    trip: "Adventure Kashmir · 5 Nights",
    rating: 5,
    image: "/images/review-horses.jpg",
    text: "What stood out was the local help — we could reach out anytime for suggestions, from where to eat in Srinagar to whether the Gondola was running that morning. It felt like having a friend in Kashmir.",
  },
];
